import { localized } from "@msuite/ui/localization";
import { createColumnHelper, createMeta, createRowActions } from "@msuite/ui/table";
import { getArticleNumberString } from "@msuite/utils/stock";
import type { SuborderArticleListItem } from "@msuite/utils/types";
import { columns as quantityTableColumns } from "../quantity-table-config";

const columnHelper = createColumnHelper<SuborderArticleListItem>();

export const columns = [
	columnHelper.accessor(
		(row) =>
			getArticleNumberString(
				row.articleGroupNumber,
				row.articleProductTypeNumber,
				row.articleNumber,
			),
		{
			id: "number",
			header: localized("general.number"),
			cell: (cell) => cell.getValue(),
			meta: createMeta({
				isTabular: true,
			}),
		},
	),
	columnHelper.accessor("name", {
		id: "name",
		header: localized("general.name"),
		cell: (cell) => cell.getValue(),
	}),
	...quantityTableColumns,
	createRowActions(() => {
		return null as any;
	}),
];
